<template>
    <div>
        <b-modal :id="modalId"
                 @hidden="onModalHidden()"
                 modal-class="modal-share"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <p v-html="title"></p>
                    <img src="@/assets/icon/ic-close.svg" @click="hide()"/>
                </div>
                <div class="modal-divine"></div>

                <div class="modal-base-grid-img">
                    <div class="modal-base-col" @click="shareLink('facebook')">
                        <img src="@/assets/new/icon/ic-facebook.svg" />
                        <div class="modal-text">Facebook</div>
                    </div>
                    <div class="modal-base-col" @click="shareLink('twitter')">
                        <img src="@/assets/new/icon/ic-twitter.svg" />
                        <div class="modal-text">Twitter</div>
                    </div>
                </div>

                <div class="modal-base-body">
                    <p class="pb-4" v-html="message"></p>
                    <div class="modal-copy">
                        <div class="modal-url">
                            {{ `${url}` }}
                        </div>
                        <div class="modal-copy-end" @click="copyUrl()">
                            <div class="modal-divine-vertical"></div>
                            <div class="modal-text-copy">
                                <img src="@/assets/new/icon/ic-copy.svg" />
                                {{ lbl.detail.copy }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-base-footer">
                </div>
                <div class="copied" :class="copyTxt && 'copied-animated'">
                    <img src="@/assets/icon/ic-check-mark.svg" />
                    <span>{{ lbl.detail.copied }}</span>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Locale from "@/helper/locale/Locale.js";
import Util from "@/helper/Utility.js";
/**
 * @property {ShareModalController} controller (required) /components/Modal/Controller/ShareModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "ShareModal",
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String,
    },
    data: function() {
        return {
            title: '',
            message: '',
            url: '',
            btnOk: '',
            btnCancel: '',
            tag: '',
            busModal: null,
            lbl: Locale.getLbl(),
            copyTxt: false,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel({ tag: this.tag });
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.url = config.url;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;
            this.tag = config.tag;
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            if (Util.isEmptyStr(config.btnCancel)) {
                this.btnCancel = this.lbl.default.cancel;
            }
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
        shareLink: function(type) {
            let targetUrl
            if(type === 'facebook') {
                targetUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.url);
            }else {
                targetUrl = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(this.url);
            }
            window.open(targetUrl, '_blank');
            // window.open(targetUrl, '_blank', "width=600,height=400");
        },
        copyUrl: function() {
            navigator.clipboard.writeText(this.url);
            this.copyTxt = true
            setTimeout(() => this.copyTxt = false, 2000)
        }
    },
}
</script>
<style lang="scss">
    @import '@/style/base/base.scss';
    @import "@/style/modal.scss";
    .modal-share {
        @extend %modal-base;
        .modal-body {
            padding: 24px;
            .modal-base {
                // text-align: center;

                .modal-base-head {
                    display: flex;
                    justify-content: space-between;
                    p {
                        font-family: $ff-semi-bold;
                        color: $a-black-333333;
                        font-size: 18px;
                    }

                    img {
                        cursor: pointer;
                    }
                }

                .modal-divine {
                    height: 1px;
                    flex-grow: 0;
                    margin: 7.5px 0 15.5px;
                    background-color: #e5e5e5;
                }

                .modal-base-grid-img {
                    display: grid;
                    grid-template-columns: auto auto;

                    .modal-base-col {
                        margin-left: auto;
                        margin-right: auto;
                        cursor: pointer;

                        img {
                            width: 80px;
                            height: 80px;
                            margin-bottom: 16px;
                        }

                        .modal-text {
                            text-align: center;
                            font-size: 16px;
                            font-family: $ff-reg;
                            color: $a-gray-999999;
                        }
                    }
                }

                .modal-base-body {
                    margin-top: 32px;
                    p {
                        font-family: $ff-reg;
                        color: $a-black-333333;
                        font-size: 18px;
                    }

                    .modal-copy {
                        display: flex;

                        align-items: center;
                        justify-content: space-between;
                        padding: 7px 15px 7px 23px;
                        border-radius: 8px;
                        background-color: $a-gray-f6f6f6;
                        font-size: 16px;
                        font-family: $ff-reg;
                        color: $a-black-333333;

                        .modal-url {
                             /* Make sure the text doesn't overflow its container */
                            overflow: hidden;
                            /* Wrap the text at the end of the line if it's too long */
                            word-wrap: break-word;
                            /* Wrap the text mid-word if it's too long */
                            overflow-wrap: break-word;
                            /* Display the text on two lines at most */
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: vertical;
                            margin-right: 14px;
                        }

                        .modal-copy-end {
                            display: flex;
                            align-items: center;
                            min-width: 84px;
                            cursor: pointer;
                            .modal-divine-vertical {
                                height: 36px;
                                margin-right: 14px;
                                border-left: 1px solid $a-gray-e5e5e5;
                            }

                            .modal-text-copy {
                                font-size: 16px;
                                font-family: $ff-reg;
                                color: $a-orange-f8a51b;
                            }
                        }
                    }
                }

                .modal-base-footer{
                    display: flex;
                    font-size: $font-18;
                    font-family: $ff-bold;
                    gap: 16px;
                    height: 45px;

                    .btn-secondary{
                        flex: 1;
                        background-color: white;
                        border: 1px solid $a-orange-f8a51b;
                        color: $main-orange-color;
                        border-radius: 10px;
                        padding: 9px 0;
                    }
                    .btn-primary{
                        flex: 1;
                        background-color: $a-orange-f8a51b;
                        border: 1px solid $a-orange-f8a51b;
                        color: white;
                        border-radius: 10px;
                        padding: 9px 0;
                    }
                }
            }
        }
    }

    .copied {
        display: none;
        // transform: translateY(-100%)
    }
    .copied-animated {
        display: block;
        position: fixed;
        display: flex;
        align-items: center;
        width: 120px;
        height: 30px;
        margin: auto;
        padding: 5px 10px;
        border-radius: 4px;
        background-color: $a-black-333333;
        opacity: 0.8;
        font-family: $ff-reg;
        font-size: 14px;
        text-align: center;
        color: white;
        top: 33.33%;
        bottom: 33.33%;
        left: 33.33%;
        right: 33.33%;
        // transform: translateY(100%)
    }
</style>
